import ApiService from "@/services/api.service"

export const ClinicService = {
  saveData(params) {
    return ApiService.post(`clinic/data/save`, params, {'Content-Type': 'multipart/form-data'})
  },
  patchClinic(params) {
    return ApiService.patch(`clinic/patch`, params)
  },
  saveCurrencyRates(rates) {
    return ApiService.post(`clinic/currencies/save`, rates)
  },
  recountServicesExchangeRate(currencyRate) {
    return ApiService.post(`clinic/currencies/${currencyRate.id}/recount`)
  },
  getContactInfo() {
    return ApiService.get("clinic/info")
  },
  updateBranchContacts(data) {
    return ApiService.post(`clinic/info/branch`, data, {'Content-Type': 'multipart/form-data'})
  },
  saveSMSSettings(settings, superadmin = false, clinic_id = '') {
    return ApiService.post(`${superadmin ? 'superadmin/' : ''}clinic/sms/settings?clinic_id=${clinic_id}`, { settings })
  },
  savePPOAttribute(attrs, vals, superadmin = false, clinic_id = '') {
    return ApiService.post(`${superadmin ? 'superadmin/' : ''}clinic/integrations/save?clinic_id=${clinic_id}`, { attrs, vals })
  },
  saveDynamicConfigs(items, superadmin = false, clinic_id = '', loader = true) {
    return ApiService.post(`${superadmin ? 'superadmin/' : ''}clinic/dynamic/configs/save?clinic_id=${clinic_id}`, { items }, {}, { loader })
  },
  importStandardServices() {
    return ApiService.post(`import/services/standard`)
  },
  disableStandardServices() {
    return ApiService.post(`import/services/standard/disable`)
  },
  getUsersList(users, superadmin = false) {
    return ApiService.get(`${superadmin ? 'superadmin/' : ''}clinic/binotel/users`, { users: users } )
  },
  getPopup() {
    return ApiService.get(`clinic/popup`)
  },
  getAdmins() {
    return ApiService.get(`clinic/admins`)
  },
  bulkServiceChange(params) {
    return ApiService.post(`services/bulk`, params)
  },
  bulkPatientsChange(params) {
    return ApiService.post(`patients/bulk`, params)
  },
  populateDemoData() {
    return ApiService.post(`clinic/demo/populate`)
  },
  clinicAccessResponse(params) {
    return ApiService.post(`clinic/access/response`, params)
  },
  teethStatusesForReport() {
    return ApiService.get(`/patient/teeth/statuses/clinic`)
  },
  getClinicFieldConfiguration() {
    return ApiService.get(`/clinic/fields/configuration`)
  },
  saveClinicFieldConfiguration(params) {
    return ApiService.post(`/clinic/fields/configuration`, params, {}, { loader: false })
  }

}
